<template>
    <div class="flex border-t border-l border-r border-gray-200 bg-white">
        <estimate-cost-list-update-material-dropdown #default="{ open:openConfirm, close:close }"
                                                     class="flex-1"
                                                     :item="material"
                                                     :original="item"
                                                     :type="type"
                                                     :align-right="true"
                                                     @updated="update"
                                                     @closed="closedUpdate"
                                                     menu-class="w-96"
                                                     trigger-class="flex w-full">
            <div class="flex-1 flex -ml-px -mt-px -mr-px -mb-px">
                <estimate-task-item-material-search
                    class="flex-1 flex "
                    menu-class="w-[34em]"
                    #default="{ open, query, setQuery }"
                    :store="store"
                    :estimate="estimate"
                    @selected:material="(e) => materialSelected(e,openConfirm)"
                    @change="openConfirm()"
                    :top="true"
                >
                    <div class="m-0 p-0 border border-gray-200 relative">
                        <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                                ref="autoresizable-textarea" v-if="!estimate.readonly">
                        <textarea
                            placeholder="Item..."
                            class="text-sm m-0 px-2 pt-1.5 pb-0.5 border-1 border-white shadow-none relative hover:z-10 focus:z-20 resize-none"
                            type="text"
                            ref="name"
                            v-model="material.name"
                            rows="1"
                            @focus="setQuery($event.target.value);open()"
                            @input="setQuery($event.target.value);openConfirm()"
                        ></textarea>
                        </autoresizable-textarea>
                        <div v-else
                             class="text-sm m-0 px-2 pt-1.5 pb-0.5 whitespace-pre-wrap border-none shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                             v-text="material.name"
                        ></div>
                        <page-cell
                            class="text-xs text-blue-500 border-1 border-white m-0 px-2 py-1 bg-white focus:z-20"
                            placeholder="Supplier..."
                            v-model="material.supplier"
                            :read-only="true"
                            ref="supplier"
                        ></page-cell>
                    </div>
                </estimate-task-item-material-search>

            </div>
            <div class="w-28 m-0 flex">
                <page-cell
                    currency
                    class="text-sm -ml-px -my-px px-2 py-1.5 border-gray-200"
                    :read-only="estimate.readonly"
                    placeholder="Cost..."
                    @input="openConfirm()"
                    v-model="material.cost"
                    ref="cost"
                ></page-cell>
            </div>


            <div class="w-20 m-0 -ml-px flex cursor-pointer" @mouseleave="closeDropDown">
                <div
                    class="flex flex-1 flex-col -ml-px -mt-px -mr-px -mb-px border border-gray-200 shadow-none bg-gray-50 px-2 py-1.5"
                >
                    <ui-dropdown placement="bottom-start" menu-class="p-3 w-96 z-50" class="flex w-full" ref="dropdown"
                                 trigger-class="flex w-full">
                        <template #default="{ open, close }">
                            <div class="w-full -my-px -ml-px p-0 text-sm text-right"
                                 @mouseenter="calculateAndOpen(open)">
                                {{ item.quantity | rounded }}
                            </div>
                        </template>
                        <template #menu>
                            <div class="">
                                <div class="text-gray-600 text-sm font-semibold w-full mb-1">
                                    Material usage across estimate:
                                </div>
                                <div class="max-h-96 pr-2 pt-1 overflow-y-auto">
                                    <div class="text-gray-400 text-xs w-full pl-0 pt-0" v-for="section in usage">
                                        <div class="flex">
                                            <div class="flex-grow truncate">Section : <span
                                                class="text-gray-600 text-sm"
                                                v-text="section.name"></span>
                                            </div>
                                        </div>
                                        <div class="w-full text-gray-400 text-xs pl-1.5" v-for="task in section.tasks">
                                            <div class="flex">
                                                <div class="flex-grow truncate">Task : <span
                                                    class="text-gray-600 text-sm"
                                                    v-text="task.name"></span>
                                                </div>
                                            </div>
                                            <div class="w-full text-gray-400 text-xs pl-1.5" v-for="item in task.items">
                                                <div class="flex">
                                                    <div class="flex-grow truncate"> Item : <span
                                                        class="text-gray-600 text-sm"
                                                        v-text="item.name"></span>
                                                    </div>
                                                    <div class="text-blue-600 text-sm"
                                                         v-text="math.round(item.count,2)"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </ui-dropdown>
                </div>

            </div>
            <div class="w-28 m-0 -mx-px flex">
                <div class="w-full bg-gray-50 -my-px mr-0 border px-2 py-1.5 text-sm text-right">
                    {{ item.cost * item.quantity | toCurrency }}
                </div>
            </div>
        </estimate-cost-list-update-material-dropdown>
    </div>
</template>

<script>

import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import EstimateTaskItemMaterialSearch from "../build/EstimateTaskItemMaterialSearch.vue";
import EstimateCostListCostUpdateMaterialDropdown from "./EstimateCostListUpdateMaterialDropdown.vue";
import {resolveNumericText} from "../../../../utils";
import EstimateCostListUpdateMaterialDropdown from "./EstimateCostListUpdateMaterialDropdown.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import PageCell from "../../../ui/PageCell.vue";
import * as math from "mathjs";

export default {
    components: {
        PageCell, UiDropdown,
        EstimateCostListUpdateMaterialDropdown,
        EstimateCostListCostUpdateMaterialDropdown, EstimateTaskItemMaterialSearch, AutoresizableTextarea
    },
    props: {
        estimate: Object,
        target: Object,
        item: Object,
        store: Object,
        type: String,
    },
    data() {
        return {
            material: {name: this.item.name, supplier: this.item.supplier, cost: this.item.cost},
            resolveNumericText,
            usage: false,
            math,
        }
    },
    computed: {},
    methods: {
        closeDropDown() {
            this.$refs.dropdown.close()
        },
        calculateAndOpen(open) {
            if (!this.usage) {
                let usage = []
                let buildUsage = (section, sIndex, task, tIndex, item, iIndex, material) => {
                    let s = usage.find((u) => u.index === sIndex)
                    if (!s) {
                        s = {index: sIndex, name: section.title, tasks: []}
                        usage.push(s)
                    }
                    let t = s.tasks.find((u) => u.index === tIndex)
                    if (!t) {
                        t = {index: tIndex, name: task.reference + ' • ' + task.name, items: []}
                        s.tasks.push(t)
                    }
                    let i = t.items.find((u) => u.index === iIndex)
                    if (!i) {
                        i = {index: iIndex, name: item.reference + ' • ' + item.description, count: 0}
                        t.items.push(i)
                    }
                    i.count += parseFloat(material.quantity);
                }
                for (let sIndex = 0; sIndex < this.estimate.scopeOfWorks.length; sIndex++) {
                    let section = this.estimate.scopeOfWorks[sIndex];
                    for (let tIndex = 0; tIndex < section.tasks.length; tIndex++) {
                        let task = section.tasks[tIndex];
                        for (let iIndex = 0; iIndex < task.items.length; iIndex++) {
                            let item = task.items[iIndex];
                            if (item.quantity) {
                                if (item.bundle) {
                                    for (let bIndex = 0; bIndex < item.bundle.length; bIndex++) {
                                        let bundleItem = item.bundle[bIndex];
                                        if (bundleItem.quantity) {
                                            for (let m = 0; m < bundleItem.materials.length; m++) {
                                                let material = bundleItem.materials[m]
                                                if (material.name === this.item.name) {
                                                    buildUsage(section, sIndex, task, tIndex, item, iIndex, material)
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    for (let m = 0; m < item.materials.length; m++) {
                                        let material = item.materials[m]
                                        if (material.name === this.item.name) {
                                            buildUsage(section, sIndex, task, tIndex, item, iIndex, material)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                this.usage = usage
                this.$nextTick(() => {
                    open();
                })
            } else {
                open()
            }
        },
        materialSelected({material, supplierName, purchaseCost}, openConfirm) {
            this.material.name = material.name
            this.material.supplier = supplierName
            this.material.cost = this.resolveNumericText(purchaseCost)
            openConfirm()
        },
        update(e) {
            this.material.cost = this.resolveNumericText(this.material.cost)
            this.$emit('updateMaterial', {from: this.item, to: this.material})
        },
        closedUpdate(e) {
            this.$nextTick(() => {
                this.material = {name: this.item.name, supplier: this.item.supplier, cost: this.item.cost}
            })
        }
    },
    mounted() {
    }
}
</script>
